import { getTheme, IStackStyles, Stack } from "@fluentui/react";
import "@fluentui/react/dist/css/fabric.css";
import { InlineDrawer } from "@fluentui/react-components";
import React, { ReactNode, useContext } from "react";

import { NavigationContext } from "../../../core/configuration/navigation/NavigationContext";
import { navigationWidth, SideNavigation } from "./navigation/SideNavigation";

export interface MainContainerProps {
    children: ReactNode;
    header: ReactNode;
}

const theme = getTheme();

const styles: IStackStyles = {
    root: {
        background: theme.palette.neutralLighterAlt,
        paddingLeft: "30px",
        paddingRight: "30px",
        width: `calc(100vw - ${navigationWidth}px)`,
        minHeight: "100%",
        position: "relative",
        flex: "1",
        overflow: "auto"
    }
};

const headerStyles: IStackStyles = {
    root: {
        marginTop: 0
    }
};

export const DefaultLayout: React.FunctionComponent<MainContainerProps> = (props: MainContainerProps) => {
    const { isNavigationOpen } = useContext(NavigationContext);

    return (
        <Stack styles={{ root: { overflow: "hidden" } }}>
            <Stack styles={headerStyles}>{props.header}</Stack>
            <Stack horizontal={true} styles={{ root: { minHeight: "calc(100vh - 50px)" } }}>
                <InlineDrawer
                    open={isNavigationOpen}
                    style={{
                        width: navigationWidth,
                        overflow: "visible"
                    }}
                >
                    <SideNavigation />
                </InlineDrawer>
                <Stack styles={styles}>
                    <Stack.Item>{props.children}</Stack.Item>
                </Stack>
            </Stack>
        </Stack>
    );
};
